import React, { useId } from "react";

// Same mark as the marketing site (tf-frontend-home/src/Components/Landing/Logo.jsx).
const Logo = ({ light = false, className = "" }) => {
  // Unique per instance: a hidden copy of the logo must not own the gradient the visible one uses.
  const gradientId = `hf-logo-${useId().replace(/:/g, "")}`;
  return (
  <span className={`inline-flex items-center gap-2.5 ${className}`}>
    <svg viewBox="0 0 40 40" className="h-9 w-9" aria-hidden="true">
      <defs>
        <linearGradient id={gradientId} x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" stopColor="#2f7bff" />
          <stop offset="1" stopColor="#10b991" />
        </linearGradient>
      </defs>
      <rect width="40" height="40" rx="11" fill={`url(#${gradientId})`} />
      <path d="M17 10h6v7h7v6h-7v7h-6v-7h-7v-6h7z" fill="#fff" opacity=".95" />
      <path d="M8 22h6l2-4 3 8 2-4h11" fill="none" stroke="#0b2349" strokeOpacity=".35" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
    <span className={`font-display text-lg font-extrabold tracking-tight ${light ? "text-white" : "text-ink-900"}`}>
      Health<span className={light ? "text-care-300" : "text-brand-600"}>Frigate</span>
    </span>
  </span>
  );
};

export default Logo;
